let pageConfig = {};

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'dealerDetail',
};

// 路由
pageConfig.listRouter = 'dealerManageList';

pageConfig.reportRouter = 'dealerReportDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '财务报表'
}];

pageConfig.formRules = {
    // pileTypeName: [{
    //     required: true,
    //     message: '请填写充电桩型号名称',
    //     trigger: 'blur'
    // }],
};


export default pageConfig;